import { orchestrator } from "satcheljs";
import setHostPlatform from "../actions/setHostPlatform";
import setHostPlatformInStore from "../mutatorAction/setHostPlatformInStore";

export default orchestrator( setHostPlatform, async actionMessage => {
    // update the data in the store
    setHostPlatformInStore(actionMessage.hostPlatform);
});